import CustomFilterSelect from "./CustomFilterSelect";
const FilterErrorLoanStatus = (props: any) => {
  return (
    <CustomFilterSelect
      source="filterLoanStatus"
      label="Status"
      choices={[
        { id: "OK", name: "OK" },
        { id: "Late", name: "Late" },
        { id: "30D", name: "Delinquent > 30D" },
        { id: "60D", name: "Delinquent > 60D" },
        { id: "90D", name: "Delinquent > 90D" },
      ]}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterErrorLoanStatus;
